const parameters = {
	mosquitoBirthRate: 1,
	eggLarvaTransitionRate: 0.33,
	larvaPupaTransitionRate: 0.14,
	pupaAdultTransitionRate: 0.346,
	eggDeathRate: 0.05,
	larvaDeathRate: 0.05,
	btiLarvaDeathRate: 0,
	pupaDeathRate: 0.0167,
	mosquitoDeathRate: 0.042,
	btiMosquitoDeathRate: 0,
	humanDeathRate: 0.0000365,
	mosquitoIncubationRate: 0.2,
	humanIncubationRate: 0.1,
	humanRecoveryRate: 0.143,
	dailyBitingRateSMosquito: 0.5,
	dailyBitingRateIMosquito: 0.5,
};

const initConsts = {
	egg: 7500,
	larva: 2000,
	pupa: 0,
	sMos: 15000,
	eMos: 0,
	iMos: 0,
	sHum: 2500,
	eHum: 0,
	iHum: 1,
	rHum: 0,
};

const E = (eggCap, totalMosquitos, egg, eggLarvaTransitionRate) => {
	return (
		parameters.mosquitoBirthRate * (1 - egg / eggCap) * totalMosquitos -
		(eggLarvaTransitionRate - parameters.eggDeathRate) * egg
	);
};

const L = (
	egg,
	larva,
	eggLarvaTransitionRate,
	larvaPupaTransitionRate,
	larvaDeathRate
) => {
	return (
		eggLarvaTransitionRate * egg -
		(larvaPupaTransitionRate +
			larvaDeathRate +
			parameters.btiLarvaDeathRate) *
			larva
	);
};

const P = (larva, pupa, larvaPupaTransitionRate, pupaAdultTransitionRate) => {
	return (
		larvaPupaTransitionRate * larva -
		(pupaAdultTransitionRate + parameters.pupaDeathRate) * pupa
	);
};

const Ms = (
	pupa,
	iHum,
	tHum,
	sMos,
	pupaAdultTransitionRate,
	mosquitoDeathRate
) => {
	return (
		pupaAdultTransitionRate * pupa -
		(parameters.dailyBitingRateSMosquito * (iHum / tHum) +
			mosquitoDeathRate +
			parameters.btiMosquitoDeathRate) *
			sMos
	);
};

const Me = (iHum, tHum, Ms, Me, mosquitoDeathRate) => {
	return (
		((parameters.dailyBitingRateSMosquito * iHum) / tHum) * Ms -
		(parameters.mosquitoIncubationRate +
			mosquitoDeathRate +
			parameters.btiMosquitoDeathRate) *
			Me
	);
};

const Mi = (eMos, iMos, mosquitoDeathRate) => {
	return (
		parameters.mosquitoIncubationRate * eMos -
		(mosquitoDeathRate + parameters.btiMosquitoDeathRate) * iMos
	);
};

const s = (Mi, totalMosquitos, sHum) => {
	return (
		parameters.humanDeathRate -
		(parameters.dailyBitingRateIMosquito * (Mi / totalMosquitos) +
			parameters.humanDeathRate) *
			sHum
	);
};

const e = (Mi, totalMosquitos, sHum, eHum) => {
	return (
		parameters.dailyBitingRateIMosquito * (Mi / totalMosquitos) * sHum -
		(parameters.humanIncubationRate + parameters.humanDeathRate) * eHum
	);
};

const i = (eHum, iHum) => {
	return (
		parameters.humanIncubationRate * eHum -
		(parameters.humanRecoveryRate + parameters.humanDeathRate) * iHum
	);
};

const r = (iHum, rHum) => {
	return (
		parameters.humanRecoveryRate * iHum - parameters.humanDeathRate * rHum
	);
};

const eulersMethod = (
	init,
	dataPoints,
	eggLarvaTransitionRate,
	larvaPupaTransitionRate,
	pupaAdultTransitionRate,
	larvaDeathRate,
	mosquitoDeathRate
) => {
	const step = 0.1;
	let data = [];

	//initial data
	data.push({
		E: init[0].value,
		L: init[1].value,
		P: init[2].value,
		Ms: init[3].value,
		Me: init[4].value,
		Mi: init[5].value,
		s: init[6].value,
		e: init[7].value,
		i: init[8].value,
		r: init[9].value,
	});

	for (let it = 1; it < dataPoints; it++) {
		const totalHumans =
			data[it - 1].s + data[it - 1].e + data[it - 1].i + data[it - 1].r;
		const totalMosquitos =
			data[it - 1].Me + data[it - 1].Mi + data[it - 1].Ms;

		const eggs =
			E(
				totalHumans * 6,
				totalMosquitos,
				data[it - 1].E,
				eggLarvaTransitionRate
			) *
				step +
			data[it - 1].E;

		const larva =
			L(
				eggs,
				data[it - 1].L,
				eggLarvaTransitionRate,
				larvaPupaTransitionRate,
				larvaDeathRate
			) *
				step +
			data[it - 1].L;

		const pupa =
			P(
				larva,
				data[it - 1].P,
				larvaPupaTransitionRate,
				pupaAdultTransitionRate
			) *
				step +
			data[it - 1].P;

		const suceptibleMosquitos =
			Ms(
				data[it - 1].P,
				data[it - 1].i,
				totalHumans,
				data[it - 1].Ms,
				pupaAdultTransitionRate,
				mosquitoDeathRate
			) *
				step +
			data[it - 1].Ms;

		const exposedMosquitos =
			Me(
				data[it - 1].i,
				totalHumans,
				data[it - 1].Ms,
				data[it - 1].Me,
				mosquitoDeathRate
			) *
				step +
			data[it - 1].Me;

		const infectedMosquitos =
			Mi(data[it - 1].Me, data[it - 1].Mi, mosquitoDeathRate) * step +
			data[it - 1].Mi;

		const suceptibleHumans =
			s(data[it - 1].Mi, totalMosquitos, data[it - 1].s) * step +
			data[it - 1].s;

		const exposedHumans =
			e(data[it - 1].Mi, totalMosquitos, data[it - 1].s, data[it - 1].e) *
				step +
			data[it - 1].e;

		const infectedHumans =
			i(data[it - 1].e, data[it - 1].i) * step + data[it - 1].i;

		const recoveredHumans =
			r(data[it - 1].i, data[it - 1].r) * step + data[it - 1].r;

		data.push({
			E: eggs,
			L: larva,
			P: pupa,
			Ms: suceptibleMosquitos,
			Me: exposedMosquitos,
			Mi: infectedMosquitos,
			s: suceptibleHumans,
			e: exposedHumans,
			i: infectedHumans,
			r: recoveredHumans,
		});
	}

	return data;
};

export { initConsts, eulersMethod };
